
export const handleVoice = (lang, msg, setButtonState) => {
    const utterance = new SpeechSynthesisUtterance();

    utterance.text = msg;
    utterance.lang = lang;
    speechSynthesis.speak(utterance);

    utterance.onend = () => {
        setButtonState(true)
        console.log('stopped');
    }
}

export const handleVoiceOverLang = (lang) => {
    if (lang === "eng") {
        return "en-GB";
    } else {
        return "hi-IN"
    }
}

export const stopVoiceOver = () => {
    const synthA = window.speechSynthesis;
    synthA.pause();
    console.log("stopvoiceover");
}




export const englishVoiceOverDisclaimer = {
    ulipText: "You are buying a Unit Linked Insurance Plan under which returns are linked to markets, and are not guaranteed. Your policy has a lock-in period of 5 years and if you don’t pay the renewal premium regularly during these 5 years the policy benefits will cease to exist",
    nonUlip: "You are buying a life insurance policy. If you don’t pay the renewal premium regularly policy benefits will cease to exist and you may not be able to get all your money back on surrendering this policy."
}

export const hindiVoiceOverDisclaimer = {
    ulipText: "आप एक यूनिट लिंक्ड इंश्योरेंस प्लान खरीद रहे हैं जिसके तहत लाभ बाजारों से जुड़ा हुआ है, और इसकी गारंटी नहीं है। आपकी पॉलिसी में 5 वर्ष की लॉक-इन अवधि है और यदि आप इन 5 वर्षों के दौरान नियमित रूप से प्रीमियम का भुगतान नहीं करते हैं तो पॉलिसी के लाभ समाप्त हो जाएंगे।",
    nonUlip: "आप एक जीवन बीमा पॉलिसी खरीद रहे हैं। यदि आप नियमित रूप से प्रीमियम का भुगतान नहीं करते हैं तो पॉलिसी के लाभ समाप्त हो जाएंगे और हो सकता है कि आप इस पॉलिसी को वापस करने पर अपना सारा पैसा पाने में सक्षम न हों।"
}